//---------- User Login
export const sendOtpToLoginPhoneURL = "user/sendOtpToLoginPhone"
export const sendOtpToVerifyPhoneURL = "user/sendOtpToVerifyPhone"
export const verifyOtpAndRegisterPatientURL = "verifyOtpAndRegisterPatient"
export const userLoginURL = "loginPortal"
export const authTokenURL = "oauth/token"
export const userProfileURL = "user/userProfile"
export const forgotPasswordURL = "user/forgetPassword"
export const setNewPasswordURL = "user/setNewPassword"
export const fetchTimeZoneURL = "fetchTimeZone"
export const fetchStatesURL = "fetchStates"
export const fetchCountriesURL = "fetchCountries"
export const getBlockoutDaysURL = "ScheduleAudit/getScheduleAudit"
export const inserOrUpdateBlockoutURL =
    "ScheduleAudit/insertOrUpdateScheduleAudit"
export const getClinicsUserURL = "user/getClinicsUser"
export const getSDOHStatusByPatientURL = "mcqdone/getSDOHStatusByPatient"
export const updateLoginUserProfileURL = "user/updateUserProfileDetails"
export const getUsersURL = "user/getCounselors"
export const getAllRolesURL = "role/getAll"
export const insertOrUpdateUserRolesURL = "user/insertUserBasedOnRole"
export const getPrivilegesURL = "user/getPrivileges"
export const addOrUpdateRoleURL = "role/addOrUpdate"
export const uploadPatientsXlsxURL = "user/patient/uploadxlsx"
export const userClinicMapURL = "user/userClinicMap"
export const userProgramMapURL = "user/userProgramMap"
export const deleteUserURL = "user/deleteUser"
export const activateUserURL = "user/activateUser"
export const fetchProgramsURL = "fetchPrograms"
export const getAllUsersWithGmailUrl = "getAllClientsInfoRelatedToEmail"
export const getPatientViewPreferenceRequestURL =
    "getPatientViewPreferenceRequest"
export const insertOrUpdatePatientViewPreferenceRequestURL =
    "insertOrUpdatePatientViewPreferenceRequest"

//documents
export const getDocumentsURL = "documents"
export const uploadDocumentURL = "documents/uploadDocument"

//invoices
export const getInvoiceURL = "fetchInvoice"
export const insertInvoicePaidAmountURL = "insertInvoicePaidAmount"
export const getBillablePatientListURL = "getBillablePatientList"
export const downloadMultiPatientSummaryURL = "downloadMultiPatientSummary"

//organization
export const fetchOrganisationsURL = "fetchOrganizations"
export const insertOurUpdateOrgURL = "insertOrUpdateOrganization"
export const fetchOrganizationDetailsURL = "fetchOrganizationDetails"

//clinic
export const fetchClinicsURL = "fetchClinics"
export const insertOurUpdateClinicURL = "insertOrUpdateClinic"

//--- patients

export const fetchPatientsURL = "fetchPatients"
export const timeTrackerURL = "timeTracker"
export const fetchByMCQCodeAndPatientURL = "mcqdone/getByMCqCodeAndPatient"
export const fetchPatientById = "fetchPatientById"
export const lastConnectedURL = "callLogs/lastConnected"
export const insertOrUpdatePatientURL = "insertOrUpdatePatient"
export const insertMultiMcqCodeURL = "mcqdone/insertMultiMcqCode"
export const fetchMCQDoneByIdURL = "mcqdone/findByCreatedBy"
export const fetchMCQDoneURL = "mcqdone/updateMcq"
export const deleteMCQURL = "mcqdone/deleteMcq"
export const lifeForcesLogURL = "mcqdone/lifeForcesLog"
export const patientsURL = "patients"
export const activityURL = "activities"
export const updatePatientManualConsentURL =
    "callLogs/updatePatinetManualConsentAsDone"
export const updateSummaryStatusURL = "updateSummaryStatus"
export const getPatientDetailsURL = "getPatientDetails"
export const getMedicationsURL = "medication"
export const getConditionsURL = "condition"
export const addOrUpdatePatientConditionURL = "patientcondition/addOrUpdate"
export const addOrUpdatePatientMedicationURL = "patientmedication/addOrUpdate"
export const bulkUpdatePatientConditionURL = "patientcondition/bulk/update"
export const bulkUpdatePatientMedicationURL = "patientmedication/bulk/update"
export const getPatientMedicatonURL = "patientmedication"
export const getPatientConditionURL = "patientcondition"
export const fetchClinicBasedBHNListURL = "fetchClinicBasedBHNList"
//----statss
// export const monthlyPerformanceReportURL = "monthlyreport/getMonthlyPerformanceReport"
// export const monthlyPerformanceReportForOrgURL = "monthlyreport/getMonthlyPerformanceReportForOrg"
// export const monthlyPerformanceReportForOrgClinicURL = "monthlyreport/getMonthlyPerformanceReportForClinic"
export const getDashboardStatsURL = "dashboard/getDashBoardStats"
export const patientsOverviewURL = "monthlyreport/getPatientsOverview"
export const patientUploadLogURL = "user/patientUploadLog"
export const updatePaymentsURL = "updatePayments"
export const getPaymentIntentDetailsURL = "getPaymentIntentDetails"

//---todo or tasks
export const insertOrUpdateTodoURL = "tasks/insertOrUpdateTodoList"
export const getTodoByIdURL = "tasks/findByCreatedBy"
export const deleteTask = "tasks/deleteTask/"

//-------logTransaction
export const transactionLog = "logTransaction"

//------lookups
export const lookupsURL = "lookups"

//-----patient food dosha (Food & Dosha Impact result)
export const patientFoodDoshaURL = "patientfooddosha"

//-----consultants
export const consultantsURL = "consultants"
export const updateUserURL = "user/updateUserAccount"

//--- appointments
export const getAppointments = "appointments"
export const getAppointmentsByConsultantIdURL =
    "appointments/getAppointmentsByConsultantId"
export const getUserAppointmentTypeUrl = "appointments/userAppointmentType"
export const getAttendeeSuggestions = "appointments/getAttendences"
export const getAttendeeSuggestionsForMessageCenter =
    "appointments/getAttendencesForMessageCenter"
export const getAppointmentSlots = "appointments/appointmentSlots"
export const putAppointmentStatus = "appointments/appointmentStatus"
export const updateGoogleCalendarEvent =
    "appointments/updateGoogleCalendarEvent"
export const getUpcomingAppointmentsURL = "appointments/getUpcomingAppointment"
export const sendAppointmentPaymentLinkURL =
    "appointments/sendAppointmentPaymentLink"
export const getAppointmentPaymentDetailsURL =
    "appointments/getAppointmentPaymentDetails"
export const updateAppointmentPaymentsURL =
    "appointments/updateAppointmentPayments"
export const insertReceiptUrl = "appointments/insertReceipt"
export const updateReceiptUrl = "appointments/updateReceipt"
export const sendAppointmentLink = "appointment/reSendAppointmentLink"
export const getAppointmentReasons = "appointments/reason"
export const getClaimPayerListURL = "appointments/claimPayerList"
export const addOrUpdatePatientPaymentMethodUrl =
    "addOrUpdatePatientPaymentMethod"

//-----twilio
export const retrieveCallURL = "retrieve_call/"
export const appointmentURL = "appointments"

//Notes
export const notesURL = "notes"
export const notesTemplate = "getTemplate"
export const tempNotesURL = "tempNotes"
export const fetchAllNotesURL = "getAllNotes"
export const getNotesTemplatesURL = "getNotesTemplates"
export const emailCCMResponse = "email/CCMResponsesToClinic"

//----care plan
export const careGoalURL = "caregoal"
export const addShortTermGoalsURL = "caregoal/addShortTermGoals"
export const getShortTermGoalLogsURL = "caregoal/getLogsByShortTermGoalId"
export const updateShortTermGoalStatusURL = "caregoal/updateStatus"
export const patientCareGoalURL = "caregoal/findByPatientUserId"
export const activityUrl = "journal/add"
export const journalURL = "journal"
export const multipleActivityUrl = "journal/addjournals"
export const fetchCareActivitiesURL = "journal/getActiveJournalBycareGoalId"
export const markascompleatedMulti = "api/journaltracker/markascompleatedMulti"
export const tracker = "api/journaltracker/getActiveByPatientAndCategory"
export const FetchCarePlanFromBackend = "aipatient"
export const bulkUpdateCareplanUrl =
    "api/journaltracker/updateCareplanBasedOnLookup"
export const fetchAllCareActivities = "careActivities/findByProgramId"

//videos
export const videosURL = "video/getwithUserId"

//graphs
export const performanceReportGraphURL = "graph/performanceBeakUp"
export const engagementBreakupGraphURL = "graph/engagementBeakUp"
export const consentBreakupGraphURL = "graph/consentBeakUp"
export const assessmentBreakupGraphURL = "graph/patinetAssesmentScore"

//screen 54
export const overviewURL = "screen_54"

//call logs
export const callLogsURL = "callLogs"
export const callLogsUpdate = "callLogs/updateCallLog"
export const callLogsPatientURL = "callLogs/patient"
export const inpersonViewUpdateURL = "conversation/media/updateViewed"
export const getCallLogWithFileId = "callLogs/getWithFileId"
export const getMediaWithPatientId = "conversation/media/getWithFileId"
// export const callLogsURL = "callLogs/getTwilioLogs"
export const updatedCallLogsURL = "callLogs/getTwilioLogs"
export const callLogsViewUpdateURL = "callLogs/updateViewed"
export const getTwilioLogsURL = "callLogs/getTwilioLogs"
export const inboundCallLogsURL = "callLogs/getInboundCallLog"
export const outboundCallLogsURL = "callLogs/getOutBoundCallLog"
export const transcriptsURL = "callLogs/transcript"
export const insertSaasCallURL = "callLogs/insertSaasCall"
export const updateSaasCallURL = "callLogs/updateSaasCall"
export const getSassCallURL = "callLogs/getSaasCall"
export const getAllCommunicationLogsUrl = "getAllCommunicationLogs"

// marketing
export const marketingSMSsentURL = "marketingSMSsent"
export const marketingsmsURL = "user/marketingsms"

//ai response storing API
export const aiResponseURL = "aipatient"
export const aiDisplayingURL = "aipatient/getPatientLatestRecord"
export const aipatientHeadersURL = "aipatient/getPatientLatestHeader"
export const docAssisstAnswersURL = "aipatient/getPatientHeaderForLookup"
export const aiCaregoalURL = "aipatient/getById"

//notifications

export const notifications = "user/patient/smsconsent?lookupId=101300001"
export const updateNotificationURL = "user/patient/smsconsent"
export const intimatePatientEmergencyURL = "user/intimatePatientEmergency"
export const intimateUserEmailURL = "user/intimateUserEmail"
export const sendSmsToPatientURL = "user/patient/sms"
export const getEmergencyTemplateURL = "user/getEmergencyTemplate"
export const getMessageCenterTemplateURL = "user/getMessageCenterTemplate"
export const getRoleBasedPrivilegesURL = "user/getRoleBasedPrivileges"
export const updatePrivilagesForTheRoleURL = "role/updatePrivilagesForTheRole"
export const itSupportEmailURL = "user/itsupportemail"
export const hardAlertemailURL = "user/hardAlertemail"

//reports

export const monthlyConsentGlobal = "/monthlyreport/getConsentGlobalLevel"
export const consentReportURL = "/monthlyreport/getConsentReport"
export const getPerformanceReportBeakDown =
    "/monthlyreport/getPerformanceReportBeakDown"
export const aptReportURL = "/monthlyreport/getAppointmentReport"

export const revenueReportURL = "/monthlyreport/getMonthlyRevenueReport"

export const carePerformanceReportURL = "/monthlyreport/getPerformanceReport"

export const bhnReportURL = "monthlyreport/getBhnsTimeSpent"

export const mstReportURL = "/monthlyreport/getmcqDoneReport"

export const carePlanReportURL = "/monthlyreport/getJournalMonthLyReport"

export const getPatientLevelPerformanceReport =
    "/monthlyreport/getDetailsOfPatientUnderCarePerformanceReport"
export const downloadAllReportURL = "/reportdownload/getConsentReport"

//api endpoints for docassist
// export const docAssistAddData = "/add_data"
// export const docAssistTrain = "/train"
// export const docAssistAsk = "/ask"

// patient billing summary
export const patientDemographic = "/getPatientDemographic"
export const patientAssessmentNamesScores = "/getPatientMoodScore"
export const patientSummaryNotes = "/getPatientNotes"
export const patientCarePercent = "/getPatientCarePercent"
export const patientAssessmentResponses = "/getAssessmentResponses"
export const patientAppointment = "/getAppointments"
export const patientCareGoals = "/getCareGoals"
export const patientFooter = "/getPatientClinicDetails"
export const getOrganizationTemplate = "/fetchPatientInvoiceTemplate"
export const saveOrgTemplate = "/insertPatientInvoiceTemplate"
export const shareViaEmail = "/sendBillableList"
export const patientCptCode = "/fetchCPTCodesBasedOnProgram"

//assessments
export const getAssessments = "mcqdone/getAssesesments"
export const createAssessment = "mcqdone/insertMCQSInAssessmentCustom"
export const editAssessmentUrl = "mcqdone/editAssesesment"
export const assessmentrangedescurl = "mcqdone/getMCQScoreRangeAndDescription"
export const insertassessmentrangedescurl =
    "mcqdone/insertMCQScoreRangeAndDescription"
export const updateassessmentrangedescurl =
    "mcqdone/updateMCQScoreRangeAndDescription"

export const herbalFormulaUrl = "herbal-formula"
export const herbalOrderUrl = "herbal-order"
export const patientPrescriptionsUrl = "patient-prescriptions"

// handout materials
export const handoutMaterialsURL = "handoutMaterials"
export const uploadHandoutMaterialURL = "handoutMaterials/insertOrUpdate"
export const deleteHandoutMaterialURL = "handoutMaterials/delete"
